<script>
  import SimpleBar from 'simplebar';
  import { createEventDispatcher, onMount } from 'svelte';

  import '@vendor/simplebar.css';
  import EmojiButton from './EmojiButton.svelte';
  import Ajax from '@utils/ajax';
  import StorageService from '@utils/storage';

  const dispatch = createEventDispatcher();
  import jQuery from 'jquery';

  export let mobile;
  let emojis = [];
  let mostPopularEmojis = [];
  let mostPopularEmojisSortFn = (a, b) => (a.most_popular_sort_order > b.most_popular_sort_order ? 1 : -1);
  let scrollableEl;
  let searchTerm = '';
  let emojiLocalStorageKey;
  let typingInterval = null;
  let loading = false;
  let updatedAtUrlResp = {};

  let fetchEmojis = async (searchTerm, url) => {
    if (searchTerm.length === 0) {
      const resp = await Ajax.get({
        url: url,
        data: {
          q_emoji: {
            name_or_aliases_cont: searchTerm,
          },
          size: 4000,
          excluded_terms: 'skin tone',
        },
      });

      return resp;
    } else if (searchTerm.length > 0) {
      const resp = await Ajax.get({
        url: url,
        data: {
          q_emoji: {
            name_or_aliases_cont: searchTerm,
          },
        },
      });

      return resp;
    }
  };

  let emojiKeyUp = function (e) {
    searchTerm = e.target.value;

    if (typingInterval) {
      clearInterval(typingInterval);
    }

    typingInterval = setInterval(async function () {
      clearInterval(typingInterval);
      const storedEmojis = StorageService.getItemFromLocalStorage(emojiLocalStorageKey);

      if (searchTerm == '' && storedEmojis) {
        emojis = storedEmojis.data;
      } else {
        loading = true;
        try {
          const searchData = await fetchEmojis(searchTerm, emojiLocalStorageKey);

          loading = false;
          emojis = searchData;
        } catch {}
      }
    }, 500);
  };

  let focusInput = function (node) {
    if (!mobile) {
      jQuery(node).focus();
    }
  };

  let setupSimpleBar = function (node) {
    new SimpleBar(node, {
      autoHide: false,
      forceVisible: true,
      drag: true,
    });

    const slider = jQuery(node).find('.simplebar-content-wrapper')[0];
    let isDown = false;
    let startX;
    let scrollLeft;

    slider.addEventListener('mousedown', (e) => {
      isDown = true;
      slider.classList.add('active');
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });
    slider.addEventListener('mouseleave', () => {
      isDown = false;
      slider.classList.remove('active');
    });
    slider.addEventListener('mouseup', () => {
      isDown = false;
      slider.classList.remove('active');
    });
    slider.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 3;
      slider.scrollLeft = scrollLeft - walk;
    });
  };

  let setEmojis = async (data, setStorage, updatedAtTimestamp, key) => {
    if (setStorage) {
      await StorageService.updateLocalStorageAndStore(key, data, updatedAtTimestamp);
    }

    emojis = [...data];
    mostPopularEmojis = emojis.filter((i) => i.most_popular_sort_order).sort(mostPopularEmojisSortFn);

    loading = false;
  };

  onMount(async () => {
    loading = true;
    const key = '/emojis';
    emojiLocalStorageKey = key;
    const updatedAtUrl = key + '/updated_at';

    updatedAtUrlResp = await Ajax.get({
      url: updatedAtUrl,
    });

    const updateAtTimestamp = updatedAtUrlResp.updated_at;

    if (StorageService.isExpired(key, updateAtTimestamp)) {
      const data = await fetchEmojis('', key);
      await setEmojis(data, true, updateAtTimestamp, key);
    } else {
      const storedEmojis = StorageService.getItemFromLocalStorage(key);
      await setEmojis(storedEmojis.data, false, updateAtTimestamp, key);
    }
  });
</script>

<style style="text/scss" lang="scss">
  * :global(.emoji-flex-container) {
    display: flex;
    flex-direction: row;
  }

  * :global(.emoji-content-section) {
    display: flex;
    flex-direction: column;
    font-size: 13px;
    padding-bottom: 17px;
  }

  * :global(.emoji-content-section-heading) {
    font-size: 13px;
    margin-bottom: 2px;
    margin-top: 12px;
    color: #8c8c8c;
  }

  .emoji-picker {
    position: absolute;
    max-width: 390px;
    width: 390px;
    min-height: 260px;
    display: flex;
    flex-direction: column;
    padding: 30px;
    background: #fff;
    border-radius: 15px;
    box-shadow: 0 22px 100px rgba(0, 0, 0, 0.18);
    font-weight: normal;

    &.mobile {
      width: 89%;
    }

    .emoji-search {
      position: relative;

      .emoji-search-icon {
        position: absolute;
        top: 50%;
        left: 16px;
        transform: translateY(-50%);
      }

      .emoji-search-input {
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;

        height: 48px;
        border: 2px solid #ececec;
        border-radius: 15px;
        padding: 0 54px;
        color: rgba(0, 0, 0, 0.5);
        width: 100%;
        font-size: 14px;

        &:focus {
          outline: none;
        }
      }
    }

    .emoji-list {
      padding-bottom: 15px;
      margin-bottom: -15px;
      width: 100%;
      height: 100%;
    }
  }

  .selector-group {
    padding-left: -5px;
    padding-right: -5px;
    flex-wrap: wrap;
    display: flex;
    width: 100%;
    flex: 100%;
    max-height: 210px;
    flex-direction: column;
    margin-left: -5px;
    margin-top: 10px;
    &.most-popular {
      width: 240px;
    }

    .single-emoji {
      width: 50px;
      padding-left: 5px;
      padding-right: 5px;
    }
  }
</style>

<div class="emoji-picker" class:mobile={mobile}>
  <div class="emoji-search">
    <div class="emoji-search-icon">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5.37165 15.77C2.63796 13.0364 2.63796 8.60425 5.37165
          5.87059C8.10533 3.13693 12.5375 3.13693 15.2712 5.87059C18.0049
          8.60425 18.0049 13.0364 15.2712 15.77C12.5375 18.5037 8.10533 18.5037
          5.37165 15.77ZM6.78587 7.2848C4.83324 9.23741 4.83324 12.4032 6.78587
          14.3558C8.7385 16.3084 11.9043 16.3084 13.857 14.3558C15.8096 12.4032
          15.8096 9.23741 13.857 7.2848C11.9043 5.33218 8.7385 5.33218 6.78587
          7.2848Z"
          fill="#D5CFEA" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14.6142 15.1132C15.0047 14.7227 15.6379 14.7227 16.0284
          15.1132L18.0284 17.1132C18.4189 17.5037 18.4189 18.1369 18.0284
          18.5274C17.6379 18.9179 17.0047 18.9179 16.6142 18.5274L14.6142
          16.5274C14.2237 16.1369 14.2237 15.5037 14.6142 15.1132Z"
          fill="#D5CFEA" />
      </svg>
    </div>
    <input
      on:click|stopPropagation
      use:focusInput
      class="emoji-search-input"
      on:keyup={emojiKeyUp}
      placeholder="Search" />
  </div>

  {#if loading}
    <div
      style="width: 100%; display: flex; justify-content: center; margin-top:
      auto; margin-bottom: auto;">
      <i class="fa fa-spin fa-spinner" />
    </div>
  {:else}
    <div use:setupSimpleBar bind:this={scrollableEl}>
      <div class="emoji-flex-container">
        {#if searchTerm.length === 0}
          <div class="emoji-content-section" style="margin-right: 25px;">
            <div class="emoji-content-section-heading">Most Popular</div>

            <div class="selector-group most-popular">
              {#each mostPopularEmojis as mp (mp.id)}
                <div
                  class="single-emoji"
                  on:click|preventDefault={() => {
                    dispatch('emoji-selected', { emoji: mp });
                  }}>
                  <EmojiButton imageSource={mp.outside_src} />
                </div>
              {/each}
            </div>
          </div>
        {/if}
        <div class="emoji-content-section">
          {#if searchTerm.length === 0}
            <div class="emoji-content-section-heading">All</div>
          {/if}
          <div class="selector-group">
            {#each emojis as e (e.id)}
              <div
                class="single-emoji"
                on:click|preventDefault={() => {
                  dispatch('emoji-selected', { emoji: e });
                }}>
                <EmojiButton imageSource={e.outside_src} />
              </div>
            {/each}
          </div>
        </div>
      </div>
    </div>
  {/if}
</div>
